"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_web__protection__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "3bb1cf14-0ec8-4d9c-a1f9-aec452180232",
    "data-name": "Ebene 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "82b509e4-a05e-4e30-9491-63fd8edcea03",
    x1: -146.65,
    y1: 37.4,
    x2: -49.94,
    y2: 134.11,
    gradientTransform: "translate(215)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "web-protection-hi-dark"), /*#__PURE__*/React.createElement("path", {
    d: "M96,176.22a8.83,8.83,0,0,1-3.59-.76c-12.77-5.65-76.49-38.84-76.49-137.39a8.43,8.43,0,0,1,2.59-6.64c3.12-2.76,7.65-2.2,13.92-1.42,11.81,1.46,31.58,3.92,58-12.6a10.66,10.66,0,0,1,11.24,0h0C128,33.91,147.77,31.45,159.58,30c6.27-.78,10.8-1.34,13.92,1.42a8.44,8.44,0,0,1,2.58,6.67c0,98.53-63.76,131.73-76.54,137.39A8.8,8.8,0,0,1,96,176.22Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,176.22a8.83,8.83,0,0,1-3.59-.76c-12.77-5.65-76.49-38.84-76.49-137.39a8.43,8.43,0,0,1,2.59-6.64c3.12-2.76,7.65-2.2,13.92-1.42,11.81,1.46,31.58,3.92,58-12.6a10.66,10.66,0,0,1,11.24,0h0C128,33.91,147.77,31.45,159.58,30c6.27-.78,10.8-1.34,13.92,1.42a8.44,8.44,0,0,1,2.58,6.67c0,98.53-63.76,131.73-76.54,137.39A8.8,8.8,0,0,1,96,176.22Zm-72-138.79a4.75,4.75,0,0,0,0,.63c0,93.6,59.76,124.78,71.74,130.08a.82.82,0,0,0,.67,0c12-5.31,71.79-36.5,71.79-130.09a4.93,4.93,0,0,0,0-.65c-1.29-.26-4.69.17-7.48.51-12,1.5-34.39,4.28-63.19-13.74h0a2.62,2.62,0,0,0-2.76,0c-28.82,18-51.2,15.25-63.22,13.76C28.62,37.59,25.2,37.17,23.92,37.43Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,176.22a8.83,8.83,0,0,1-3.59-.76c-12.77-5.65-76.49-38.84-76.49-137.39a8.43,8.43,0,0,1,2.59-6.64c3.12-2.76,7.65-2.2,13.92-1.42,11.81,1.46,31.58,3.92,58-12.6a10.66,10.66,0,0,1,11.24,0h0C128,33.91,147.77,31.45,159.58,30c6.27-.78,10.8-1.34,13.92,1.42a8.44,8.44,0,0,1,2.58,6.67c0,98.53-63.76,131.73-76.54,137.39A8.8,8.8,0,0,1,96,176.22Zm-72-138.79a4.75,4.75,0,0,0,0,.63c0,93.6,59.76,124.78,71.74,130.08a.82.82,0,0,0,.67,0c12-5.31,71.79-36.5,71.79-130.09a4.93,4.93,0,0,0,0-.65c-1.29-.26-4.69.17-7.48.51-12,1.5-34.39,4.28-63.19-13.74h0a2.62,2.62,0,0,0-2.76,0c-28.82,18-51.2,15.25-63.22,13.76C28.62,37.59,25.2,37.17,23.92,37.43Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168,35.19c-1.29-.26-4.69.17-7.48.51C148.55,37.2,126.18,40,97.38,22h0a2.62,2.62,0,0,0-2.76,0C65.81,40,43.43,37.21,31.41,35.72c-2.79-.34-6.21-.77-7.49-.51a4.75,4.75,0,0,0,0,.63c0,.6,0,1.18,0,1.78,0-.07,0-.14,0-.19,1.28-.26,4.7.16,7.49.51,12,1.49,34.4,4.27,63.22-13.76a2.61,2.61,0,0,1,2.76,0h0c28.8,18,51.17,15.23,63.19,13.74,2.78-.35,6.19-.77,7.48-.51,0,.05,0,.12,0,.19,0-.59,0-1.16,0-1.75A4.93,4.93,0,0,0,168,35.19Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.54,173.24a8.83,8.83,0,0,1-7.17,0C79.68,167.62,16.65,134.79,15.9,37.6c0,.15,0,.3,0,.46,0,98.56,63.73,131.75,76.49,137.39a8.83,8.83,0,0,0,7.17,0c12.78-5.66,76.54-38.86,76.54-137.39,0-.17,0-.32,0-.49C175.32,134.76,112.24,167.62,99.54,173.24Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a7034dd2-e904-4843-b960-27fb34ee0582",
    "data-name": "b2ca7fa1-619f-45ca-903c-57092e202b64",
    d: "M126.87,129.33a7.15,7.15,0,0,0,5.53-8.46q0-.17-.08-.34c-5.72-22.63-21-33.22-36.12-33.22s-30.73,10.56-36.52,33.2a7.15,7.15,0,0,0,5.08,8.73l.38.09a152.12,152.12,0,0,0,31,3.17A152.12,152.12,0,0,0,126.87,129.33Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "0e448315-1007-49f4-9a36-b1f7612374a1",
    "data-name": "1630202a-192c-4069-a8a9-0572a26d12c3",
    cx: 96,
    cy: 64.59,
    r: 22.72,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.54,175.46c12.78-5.66,76.54-38.86,76.54-137.39a8.44,8.44,0,0,0-2.58-6.67c-3.12-2.76-7.65-2.2-13.92-1.42-11.81,1.47-31.57,3.93-58-12.58A10.6,10.6,0,0,0,96,15.8V176.21A8.8,8.8,0,0,0,99.54,175.46Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#82b509e4-a05e-4e30-9491-63fd8edcea03)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_web__protection__dark;
exports.default = _default;